import { Injectable } from '@angular/core';
import { Http, QueryHandlerFor, Wrapper } from '@skylab-angular-shared/core';
import { KsefEnvironmentQuery, KsefEnvironmentQueryHandlerBase } from '@skylab-shared/business';

@Injectable({ providedIn: 'root'})
@QueryHandlerFor(KsefEnvironmentQuery)
@Wrapper(KsefEnvironmentQueryHandlerBase)
export class KsefEnvironmentQueryHandler {
    public constructor(
        http: Http
    ) { }
}
